import { render } from "./pagethree.vue?vue&type=template&id=25cb3b39&scoped=true"
import script from "./pagethree.vue?vue&type=script&lang=js"
export * from "./pagethree.vue?vue&type=script&lang=js"

import "./pagethree.vue?vue&type=style&index=0&id=25cb3b39&lang=less&scoped=true"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25cb3b39"]])

export default __exports__